export default __webpack_public_path__ + "static/media/loader-pt1.10ce3de8.svg";